import type { SenderProfile, SenderProfileId } from "@gs/core/domain/SenderProfile/SenderProfile";
import { createDomainStore } from "../_utils/createDomainStore";

export const [senderProfileStore, useSenderProfileStore] = createDomainStore<SenderProfile, SenderProfileId>("senderProfile");
